'use client';
import React, { memo, useRef, useState } from 'react';
import Slider, { Settings } from 'react-slick';

import { SlideController } from '@/app/_components/home/MottoSection/config';
import { useGetFeedbacksQuery } from '@/store/api/feedback.api';
import { map } from '@/utils';
import {
	Button,
	Modal,
	ModalBody,
	ModalContent,
} from '@nextui-org/react';

import SlideCard from './SlideCard';

import { CloseSquare } from 'iconsax-react';

const settings: Settings = {
	dots: false,
	infinite: true,
	speed: 500,
	initialSlide: 0,
	centerMode: false,
	arrows: false,
	className: '*:!px-3',
	slidesToShow: 3,
	slidesToScroll: 3,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				centerMode: false,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			},
		},
		{
			breakpoint: 480,
			settings: {
				centerMode: true,
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
};

const ProudSlider = () => {
	const { data: feedbacksData } = useGetFeedbacksQuery({
		page: 1,
		pageSize: 8,
	});

	const [itemSelected, setItemSelected] = useState<any>(null);
	const onClose = () => setItemSelected(null);
	
	let sliderRef: any = useRef(null);
	const onNext = () => {
		if (!sliderRef.current) return;
		sliderRef.current.slickNext();
	};
	const onPrev = () => {
		if (!sliderRef.current) return;
		sliderRef.current.slickPrev();
	};

	return (
		<div className="w-full">
			<Slider
				ref={(slider) => {
					sliderRef.current = slider;
				}}
				{...settings}
			>
				{map(feedbacksData?.data || [], (item: any, idx: number) => (
					<SlideCard
						{...item}
						setItemSelected={setItemSelected}
						key={idx}
					/>
				))}
			</Slider>

			<SlideController
				onNext={onNext}
				onPrev={onPrev}
				className="hidden lg:flex"
				btnClass="lg:!size-9"
			/>
			<Modal
				isOpen={!!itemSelected}
				size={'5xl'}
				onClose={onClose}
				backdrop="blur"
				classNames={{
					body: 'p-6 m-4 rounded-xl bg-bittersweet outline-none mx-auto max-w-[944px] w-full',
					closeButton: 'hidden',
					wrapper: 'z-[9999] center bg-black bg-opacity-60 p-4',
				}}
				placement="center"
			>
				<ModalContent>
					{(onClose) => (
						<>
							<ModalBody className='relative'>
								<img
									src={itemSelected?.images?.[0]?.url}
									alt={'DLA Da Nang'}
									className="max-h-[80vh] object-cover object-center"
								/>
								<Button color="danger" isIconOnly onPress={onClose} className='absolute  w-10 h-10 top-[-40px] right-[-40px] z-50'>
									<CloseSquare size={40} color='#fff' />
								</Button>
							</ModalBody>
						</>
					)}
				</ModalContent>
			</Modal>
		</div>
	);
};

export default memo(ProudSlider);
